import { render } from "./CoverageStrip.vue?vue&type=template&id=39c2092e&scoped=true"
import script from "./CoverageStrip.vue?vue&type=script&lang=js"
export * from "./CoverageStrip.vue?vue&type=script&lang=js"

import "./CoverageStrip.vue?vue&type=style&index=0&id=39c2092e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c2092e"]])

export default __exports__